<template>
  <div class="nx-no-data">
    <nx-image class="img" width="130px" height="130px" :src="require('@/assets/images/icon/noData.png')"></nx-image>
    <p class="text">暂无查询结果</p>
  </div>
</template>
<script>
export default {
  name: 'NxNoData',
  components: {},
  props: {
    text: {
      type: String,
      default: '暂无查询结果',
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.nx-no-data{
  margin: 50px 0;
}
.img{
  margin: auto;
}
.text{
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #7A8499;
  line-height: 20px;
  margin-top: 10px;
}
</style>
